import {useHistory} from "react-router";
import RegisterLayout from "@/layout/RegisterLayout";
import style from './Resiger.scss'
import MButton from "@/components/atom/MButton";
import React from "react";

const Propose = () => {
  const history = useHistory()

  const toApply = () => {
    history.push('/register/apply')
  }

  const goBack = () => {
    history.push('/')
  }

  return (
    <>
      <RegisterLayout>
        <div className={style.container}>
          <h1>名刺R</h1>
          <div>
            名刺を渡した人に、年間の営業日をお伝えできます。業務内容のメニュー、その他情報をテキスト、画像でスマホに反映、その進捗内容をすでにお渡しした全員に確認していただけます。<br/>
            名刺の受取のみに使用する場合は料金がかかりませんが、名刺を渡すには名刺の登録が必要、名刺1点の登録で550円(税込)が必要で名刺のQRが作成されます。登録した名刺をお渡しするユーザー数が50名までは無料、51名〜500名まで550円/月(税込)、501名〜770円/月(税込)必要です。
          </div>
          <MButton image={'start.png'} value={'スタート'} onClick={toApply}></MButton>
          <MButton image={'back.png'} value={'戻る'} onClick={goBack}></MButton>
        </div>
      </RegisterLayout>
    </>
  )
}

export default Propose;
